import React from 'react'
import '../styles/DisplayItems.css'
import { ethers } from 'ethers'
import { abi } from "../components/abi";
import { useState } from 'react';
import axios from 'axios'

const  DisplayItems =  () => {

    const [userItems, setUserItems] = useState([])

    async function connect(){
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const accounts = await provider.send("eth_requestAccounts", []);
    console.log(accounts[0])
    const signer = provider.getSigner();
    const contractAddress = "0xf76D167A96Fff3526918aad94e2963Bf772444ad"; // walaby testnet
    const contract = new ethers.Contract(contractAddress, abi, provider);
    console.log("This is the contract ",contract)
    const costFromContract = await contract.cost();
    const exists = await contract.exists(1);

    const balanceOf = await contract.balanceOf(accounts[0],5);
     console.log("User Balance ",parseInt(balanceOf))
     console.log("exists ",exists)
    //  setUserItems([...userItems, balanceOf])
     //get token uri
     const uri = await contract.uri(5)
     console.log("uri is ",uri)
     const url= uri.slice(7);
     console.log(url)
    //  https://bafybeig4enjbtt2omx67zcnjppaqqeec6fw5bmgqk56xenbu6g5if42mqy.ipfs.w3s.link/json
    //  const ipfsGateway = "https://" + url + ".ipfs.w3s.link/json";
    //  //get image uri
    // const test= fetch(ipfsGateway).promise()
    
    //     console.log(test)
    
    
    //  const imageUri = uri.image
    //  console.log(imageUri)
     
}
   

connect()

  return (
    <div className="displayContainer">
        <h2>Display Items</h2>
        
    </div>
  )
}

export default DisplayItems